import React, { useEffect, useState } from "react";
import "./StoredetailPage.css";
import { Row, Container, Tabs, Tab } from "react-bootstrap";
import ProductsPage from "./ProductsPage";
import AboutPage from "./AboutPage";
import ReviewPage from "./ReviewPage";
import { connect, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { storeChathistory } from "../../header/redux/actions";
import { fetchHeaderContent } from "./../../seoroute/redux/actions";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  ADD_CHAT_GROUP,
  STORE_DETAIL,
  STORE_VISIT_NOTIFICATION,
} from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import LoaderPage from "../../loader/components/LoaderPage";
import { setStoreMessageReceived } from "../../chat/redux/actions";
const StoreProfile = React.lazy(() =>
  import("../../dashboard/components/StoreProfile")
);

function StoredetailPage(props) {
  let storeId = window.location.pathname.split("/").pop();
  const { t } = useTranslation();
  const [detailTab, setDetailtab] = useState("products");
  const [storedetail, setStoreDetail] = useState({});
  const [loader, setLoader] = useState(false);
  let mobileView = window.innerWidth <= 480 ? true: false;
  let tabView = window.innerWidth <= 1024 ? true: false;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storedetailTabchange = (key) => {
    setDetailtab(key);
  };

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getStoreDetail())();
    // eslint-disable-next-line
  }, []);

  const getStoreDetail = async () => {
    setLoader(true);
    let geturl = STORE_DETAIL + `/${storeId}/no`;
    let storeDetailresponse = await getRequestcall(geturl, props?.access_token);
    if (storeDetailresponse?.status === 200) {
      let storedetail = await storeDetailresponse.json();
      props?.fetchHeaderContent(storedetail?.data?.title, "", "");
      setStoreDetail({
        ...storedetail?.data,
      });
    }else{
      let storedetail = await storeDetailresponse.json();
      if(storedetail?.errors){
        navigate("/stores")
      }
    }
    setLoader(false);
    await callStorevisit();
  };

  const callStorevisit = async () => {
    let geturl =
      STORE_VISIT_NOTIFICATION +
      `/${storeId}?lang=${props?.language?.toLowerCase()}`;
    await getRequestcall(geturl, props?.access_token);
  };

  const navigateTochat = async (e) => {
    e.preventDefault();
    if (props.access_token) {
      dispatch(setStoreMessageReceived({messages:[], users_id:""}))

      let geturl =
        ADD_CHAT_GROUP +
        `?store_id=${storeId}&request_id=${""}&type=${"store"}`;
      let getResponse = await postRequestcall(geturl, props?.access_token, "");
      if (getResponse?.status === 200) {
        let getInfo = await getResponse.json();
        if (
          getInfo?.data?.jid !== null &&
          typeof getInfo?.data?.jid !== "undefined"
        ) {
          navigate(`/chat/${getInfo?.data?.jid}`);
        }
      }
    } else {
      toast.error(t("pages.Please login"));
    }
  };

  const storeProfile = () => {
      return (
        <StoreProfile 
        storedetail={storedetail}
        innerClass={"position-relative store_custome_profile"}
        className={"storeprofilediv comman "}
        storeId={storeId}
        navigate={navigateTochat}
        showchat={true}
        type={"StoreDetails"}
        storeDetails={props?.storeDetail}
      />
      )
  }

  if (loader) return <LoaderPage className={"user-dashboard"} />;

  return (
    <>
      <div className="store-detail">
        <Container>
          <Row>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              {!mobileView && storeProfile()}
              <Tabs
                activeKey={detailTab}
                onSelect={(key) => storedetailTabchange(key)}
              >
                <Tab
                  eventKey="products"
                  title={t("pages.storedetail.products.title")}
                >
                  <ProductsPage
                    detailTab={detailTab}
                    storedetail={storedetail}
                    mobileView={mobileView}
                    tabView={tabView}
                  />
                </Tab>
                <Tab eventKey="about" title={t("pages.About")}>
                  <AboutPage storedetail={storedetail} detailTab={detailTab} />
                </Tab>
                <Tab
                  eventKey="reviews"
                  title={t("pages.storedetail.products.reviews")}
                >
                  <ReviewPage detailTab={detailTab} storedetail={storedetail} />
                </Tab>
                <Tab
                  eventKey="store-info"
                  title={t('pages.Store Info')}
                  tabClassName={'store-info'}

                >
                 {storeProfile()}
                </Tab>
              </Tabs>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  storeDetail: state?.dashboard?.storeDetail,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  storeChathistory,
  fetchHeaderContent,
})(StoredetailPage);
